import { AUS_POPPER_Z_INDEX_OFFSET } from '../MainHeaderContent/HeaderViewList/HeaderViewList.constants';

export const anchorStyles = {
  display: 'inline-flex',
  alignItems: 'center',
};

export const popperStyles = {
  zIndex: ({ zIndex }) => `${zIndex.modal + AUS_POPPER_Z_INDEX_OFFSET} !important`,
};
